module.exports = __webpack_public_path__ + "static/img/SmileAnimation_cocopineapple.d6ca9cd.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/SmileAnimation_cocopineapple.gif
// module id = 9Loz
// module chunks = 0